import React, { lazy, useEffect, Suspense } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import QuickAccessNav from "./components/QuickAccessNav";
import Header from "./components/Header";
import Navigation from "./components/Navigation";
import Footer from "./components/Footer";
const HomePage = lazy(() => import("./pages/home/page"));
const ContactPage = lazy(() => import("./pages/contact/page"));
const HistoryPage = lazy(() => import("./pages/history/page"));

function App() {
  useEffect(() => {
    // Google Analytics (matching original)
    const script1 = document.createElement("script");
    script1.async = true;
    script1.src = "https://www.googletagmanager.com/gtag/js?id=G-2QHR2W2654";
    document.head.appendChild(script1);

    const script2 = document.createElement("script");
    script2.innerHTML = `
      window.dataLayer = window.dataLayer || [];
      function gtag(){dataLayer.push(arguments);}
      gtag('js', new Date());
      gtag('config', 'G-2QHR2W2654');
    `;
    document.head.appendChild(script2);

    return () => {
      try {
        document.head.removeChild(script1);
        document.head.removeChild(script2);
      } catch (e) {}
    };
  }, []);

  return (
    <Router>
      <div className="controls-visible yui3-skin-sam signed-out public-page site">
        <QuickAccessNav />
        <div className="container-fluid" id="wrapper">
          <Header />
          <Navigation />
          <div id="content" className="pt-[20px]">
            <Suspense fallback={<div>Loading...</div>}>
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/home" element={<HomePage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/history" element={<HistoryPage />} />
              </Routes>
            </Suspense>
          </div>
          <Footer />
        </div>
      </div>
    </Router>
  );
}

export default App;
